import { getAbsoluteUrl } from "./urls";

export type PortalDocType =
  | "invoice"
  | "credit_note"
  | "debit_note"
  | "remission_note";

export interface PortalTaxPayerBranding {
  socialName: string;
  fantasyName: string | null;
  logoUrl: string | null;
}

export interface PortalDocumentResult {
  type: PortalDocType;
  typeLabel: string;
  date: string;
  formattedNumber: string;
  kudeToken: string;
}

export interface PortalSearchResponse {
  results?: PortalDocumentResult[];
  warning?: boolean;
  code?: string;
  message?: string;
}

export const getPortalTaxPayer = async (
  uniqueId: string,
): Promise<PortalTaxPayerBranding | null> => {
  const res = await fetch(getAbsoluteUrl(`/public-portal/${encodeURIComponent(uniqueId)}`), {
    method: "GET",
    credentials: "omit",
  });
  if (!res.ok) return null;
  return (await res.json()) as PortalTaxPayerBranding;
};

export const searchPortalDocuments = async (
  uniqueId: string,
  ruc: string,
  documentNumber: string,
  turnstileToken?: string,
): Promise<PortalSearchResponse> => {
  const res = await fetch(
    getAbsoluteUrl(`/public-portal/${encodeURIComponent(uniqueId)}/search`),
    {
      method: "POST",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ruc, documentNumber, turnstileToken }),
    },
  );
  return (await res.json()) as PortalSearchResponse;
};

export const portalKudeUrl = (kudeToken: string): string =>
  getAbsoluteUrl(`/public-portal/kude/${encodeURIComponent(kudeToken)}`);
